<script setup>
import { ref, computed, watch, nextTick } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { useSettingsStore } from '@/stores/settingsStore';
import { useScrollStore } from '@/stores/scrollStore';
import SertFirstScreen from '@/components/blocks/SertFirstScreen.vue'
import SertAuthPhone from '@/components/blocks/SertAuthPhone.vue'
import SertAuthSms from '@/components/blocks/SertAuthSms.vue'
import SertAuthUserData from '@/components/blocks/SertAuthUserData.vue'
import SertDesign from '@/components/blocks/SertDesign.vue'
import SertRecipient from '@/components/blocks/SertRecipient.vue';
import SertSum from '@/components/blocks/SertSum.vue';
import SertPreview from '@/components/blocks/SertPreview.vue';
import SertPay from '@/components/blocks/SertPay.vue';
import SertChecked from '@/components/blocks/SertChecked.vue';
import SertThankYou from '@/components/blocks/SertThankYou.vue';
import SertErrorPay from '@/components/blocks/SertErrorPay.vue';

const storeSert = useSertStore();
const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();

watch(
	() => storeSert.currentScreen,
	() => {
		nextTick(() => {
			storeScroll.scrollToId('constructor')
		});
	}
);

const shwoMainImage = computed(() =>
{	return storeSert.currentScreen === storeSert.screens.firstScreen ||
		storeSert.currentScreen === storeSert.screens.authPhone ||
		storeSert.currentScreen === storeSert.screens.authSms ||
		storeSert.currentScreen === storeSert.screens.authUserData
})

const formatted = computed(() => new Intl.NumberFormat('ru-RU').format(storeSert.checkedItems.select.title))

</script>
<template>
    <section class="sert section" id="constructor">
		<div :class="['sert__container', {'--first-screen': storeSert.currentScreen === storeSert.screens.firstScreen}]">
			<Transition name="slide-up" mode="out-in">
				<SertFirstScreen v-if="storeSert.currentScreen === storeSert.screens.firstScreen"/>
				<SertAuthPhone v-else-if="storeSert.currentScreen === storeSert.screens.authPhone"/> <!-- storeSert.currentScreen === storeSert.screens.authPhone -->
				<SertAuthSms v-else-if="storeSert.currentScreen === storeSert.screens.authSms"/>
				<SertAuthUserData v-else-if="storeSert.currentScreen === storeSert.screens.authUserData"/>
				<SertDesign v-else-if="storeSert.currentScreen === storeSert.screens.design "/> <!-- storeSert.currentScreen === storeSert.screens.design -->
				<SertRecipient v-else-if="storeSert.currentScreen === storeSert.screens.recipient"/>
				<SertSum v-else-if="storeSert.currentScreen === storeSert.screens.sum"/>
				<SertPreview v-else-if="storeSert.currentScreen === storeSert.screens.preview"/>
				<SertPay v-else-if="storeSert.currentScreen === storeSert.screens.pay"/>
				<SertChecked v-else-if="storeSert.currentScreen === storeSert.screens.checked"/>
				<SertThankYou v-else-if="storeSert.currentScreen === storeSert.screens.thank"/>
				<SertErrorPay v-else-if="storeSert.currentScreen === storeSert.screens.errorPay"/>
			</Transition>
				
			
			<div class="sert__preview preview" 
				v-if="shwoMainImage" 
				data-animation-right
			>
				<h3 class="preview__title">GIFT CARD</h3>
				<div class="preview__header">
					<span>Данная карта дарит</span>
					<span>Получателю</span>
					<span>подарочный сертификат</span>
					<span>на выбранную вами сумму</span>
				</div>
				<div class="preview__image">
					<img class='full-img' 
						width='658' height='340' 
						src='@/assets/img/constructor/image_constructor.webp' 
						srcset='@/assets/img/constructor/image_constructor@2x.webp 2x' alt='изображение'
					>
				</div>
				<div class="preview__desc">
					<p>
						Персональное обращение! <br>
						Этот текст поможет понять, где именно
						будет отображаться персональное обращение
						на сертификате.
					</p>
				</div>
				<div class="preview__footer">
					<a href="https://therinkfitness.ru/" class="preview__footer-link">therinkfitness.ru</a>
					<a :href="`tel:${storeSettings.contactsPhone}`" class="preview__footer-link">{{ storeSettings.contactsPhone }}</a>
					<span class="preview__footer-link">{{ storeSettings.contactsAddress }}</span>
					<a href="#wrapper" class="logo">
						<img class='' width='132' height='43' src='@/assets/img/icons/logo.svg' alt='изображение'>
					</a>
				</div>
			</div>
			<div class="sert__preview preview" id="previewSert" v-else>
				<h3 class="preview__title">GIFT CARD</h3>
				<div class="preview__header">
					<span>Данная карта дарит</span>
					<span>{{ storeSert.checkedItems.userName.title }}</span>
					<span v-if="!!storeSert.checkedItems.select.title">подарочный сертификат на сумму</span>
					<span v-if="!!storeSert.checkedItems.select.title"><strong>{{ formatted }} рублей</strong> </span>
					<span v-if="!storeSert.checkedItems.select.title"></span>
					<span v-if="!storeSert.checkedItems.select.title"></span>
				</div>
				<div class="preview__image">
					<img :class="!storeSert.checkedItems.imagePath.title ? '' : 'full-img'" 
						width='' height='' 
						:src="!storeSert.checkedItems.imagePath.title ? '/img/no_image.png' : storeSert.checkedItems.imagePath.title" 
						alt='изображение'
					>
				</div>
				<div class="preview__desc">
					<p>{{ storeSert.checkedItems.message.title }}</p>
				</div>
				<div class="preview__footer">
					<a href="#" class="preview__footer-link">therinkfitness.ru</a>
					<a href="tel:+7 995 307 2323" class="preview__footer-link">+7 995 307 2323</a>
					<span class="preview__footer-link">Сколково, улица Новая, 100</span>
					<a href="#wrapper" class="logo">
						<img class='' width='132' height='43' src='@/assets/img/icons/logo.svg' alt='изображение'>
					</a>
				</div>
			</div>
		</div>
       
    </section>
</template>
<style lang='scss' scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>